import { render, staticRenderFns } from "./DataChange.vue?vue&type=template&id=6e0909db&"
import script from "./DataChange.vue?vue&type=script&lang=js&"
export * from "./DataChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports